/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * User reducer
 */

import { User } from "@thenounproject/lingo-core";

import createEntityReducer from "../helpers/createEntityReducer";
import { mergeEntitiesIfChanged } from "../helpers/mergeIfChanged";

export default createEntityReducer<User>(
  "users",
  _queryBuilder => {
    // nothing to do here yet...
  },
  objectBuilder => {
    objectBuilder.addDefaultCase((state, action: any) => {
      const users = action.response?.entities?.users ?? action.payload?.entities?.users;
      if (users) {
        return mergeEntitiesIfChanged(state, users);
      }
      return state;
    });
  }
);
